var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","data-role":"page"},on:{"mousemove":_vm.moveEvent,"click":_vm.moveEvent}},[_c('router-view',{staticClass:"vh_div"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }